import { IServiceProvider } from './../../configuration/modules/modules.types';
import { createServiceProvider } from '../../configuration/modules/service.provider';
import { routerFactory } from './router.factory';
import { ActiveRoute, RouteConfig } from '../../components-common/routes';
import { toDynamicRoute } from '../../components-common/_utils/helpers.screens';
import { buildNestedRoutes } from '../../components-system/routing/create-nested-routes';

const createRouteProvider = (): IServiceProvider & {
  activeRoute: () => ActiveRoute;
  get: (id: string) => any;
} => {
  const provider = createServiceProvider();
  const activeRoute = () => provider.resolve<ActiveRoute>('route-active');
  const get = (id: string) => provider.resolve<RouteConfig>(id);
  return {
    ...provider,
    activeRoute,
    get,
  };
};

export const createRoutingService = () => {
  const provider = createRouteProvider();
  const routeFactory = routerFactory();
  let router: any;

  const start = () => (router = routeFactory.create());

  const mapAndAdd = (service: IServiceProvider) => (screens: any) => {
    const mappedRoutes = buildNestedRoutes(screens);
    mappedRoutes.forEach((route: any) => {
      const toStore = {
        key: route?.id ?? route?.key ?? 'not-set',
        value: route,
      };
      service.register(toStore.key, toStore.value);
    });

    return mappedRoutes;
  };

  const addRootieRoutes = (routes: any[]) => {
    const mappedRoutes = mapAndAdd(provider)(routes);
    addRoutes(mappedRoutes);
  };

  const addRoutes = (routes: any[]) => routeFactory.add(routes);

  return {
    start,
    router: () => router.getRouter(),
    addRootieRoutes,
    addRoutes,
    get: provider.get,
    printAll: provider.printAll,
  };
};
